import base from "./base.service";

const instance = base.service();

export const addPonudjeniOdgovor = (noviPonudjeniOdgovor) => {
    return instance.post("/ponudjeniOdgovor", noviPonudjeniOdgovor);
};

export const getById = (id) =>
{
    return instance.get(`/ponudjeniOdgovor/${id}`);
}

export const getByPitanjeId = (id) =>
    {
        return instance.get(`/pitanje/${id}/ponudjeniOdgovori`);
    }

    export const updatePonudjeniOdgovor = (id, updatedPonudjeniOdgovor) =>
        {
            return instance.put(`/ponudjeniOdgovor/${id}`, updatedPonudjeniOdgovor);
        }

    export const deletePonudjeniOdgovor = (id) =>
    {
        return instance.delete(`/ponudjeniOdgovor/${id}`);
    }
    

export default {
    addPonudjeniOdgovor, getById, getByPitanjeId, updatePonudjeniOdgovor, deletePonudjeniOdgovor
};